module.exports = "<a :href=\"link || 'javascript:;'\" v-link=\"routerLink\" class=\"weui_media_box\" :class=\"typeClass\" v-if=\"!!link || !!routerLink\">\n  <slot></slot>\n</a>\n<div class=\"weui_media_box\" :class=\"typeClass\" v-else>\n  <slot></slot>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-box.vue
 ** module id = 158
 ** module chunks = 0
 **/